import { ReadinessBenefits } from "@/components/readiness/ReadinessBenefits";
import { ReadinessChatSection } from "@/components/readiness/ReadinessChatSection";
import { ReadinessClosing } from "@/components/readiness/ReadinessClosing";
import { ReadinessHero } from "@/components/readiness/ReadinessHero";

export default function ReadinessAssessmentStart() {
  return (
    <main className="readiness-page" data-testid="readiness-assessment-start-page">
      <ReadinessHero />
      <ReadinessBenefits />
      <ReadinessChatSection />
      <ReadinessClosing />
    </main>
  );
}